import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { register } from "../features/auth/authSlice"; // Ensure this path is correct
import { toast } from "react-toastify";
import discount2 from "../image/discount2.png";
// import JanhitChemist from "../image/Janhit Chemist.png"; 
import finallogo from "../image/finallogo.png"

import { Link, useNavigate } from "react-router-dom";

const RegistrationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();                 
 

  const handleLogoClick = () => {
    navigate("/"); // This will navigate to the homepage
  }; 
  
  const formik = useFormik({
    initialValues: {
      name: "",
      mobile: "",
      email: "",
      password: "",
      role: "user",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .required("Password is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await dispatch(register(values)).unwrap();
        toast.success("Registration successful!");
        navigate("/login");
      } catch (error) {
        toast.error("Registration failed!");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <div className="brand-logo">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 col-xs-12">
              <div className="brand-logo-main text-center">
                <img
                  src={finallogo}
                  alt="Logo"
                  onClick={handleLogoClick} // Add click handler
                  style={{ cursor: "pointer" }} // Optional: to change cursor to pointer on hover
                />
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-7 col-12 col-xs-12 text-center weltezt">
              <img src={discount2} alt="Discount Banner" />
              <h5>Welcome to Janhit Chemist</h5>
              <p>
                Sign up with us and get exclusive discounts and savings on
                medicines. Get express delivery in 2 hours.
              </p>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-5 col-12 col-xs-12">
              <div className="from-section">
                <h5>Sign Up</h5>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        formik.touched.name && formik.errors.name
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="name"
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="invalid-feedback">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <input
                      type="text"
                      className={`form-control ${
                        formik.touched.mobile && formik.errors.mobile
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Phone Number"
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="mobile"
                    />
                    {formik.touched.mobile && formik.errors.mobile ? (
                      <div className="invalid-feedback">
                        {formik.errors.mobile}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <input
                      type="email"
                      className={`form-control ${
                        formik.touched.email && formik.errors.email
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="email"
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="invalid-feedback">
                        {formik.errors.email}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <input
                      type="password"
                      className={`form-control ${
                        formik.touched.password && formik.errors.password
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      name="password"
                    />
                    {formik.touched.password && formik.errors.password ? (
                      <div className="invalid-feedback">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={formik.isSubmitting}
                  >
                    Submit
                  </button>
                </form>
                <div className="divider text-center my-3">
                  <p>
                    <span>or</span>
                  </p>
                </div>
                <p className="already-login text-center">
                  Already have an account?
                  <Link to="/login">Sign In</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegistrationPage;
